<template>
	<app-title-bar
		p-title-bar
		:icon="['fas', 'fa-truck']"
		subtitle="Yard App"
		title="Load Items All Contracts">
		<app-button to="/yard-app" icon="fa-circle-left"> Back </app-button>
	</app-title-bar>

	<app-panel title="Load Contracts">
		<load-table
			:loading
			:items
			:total
			@params-changed="(newParams: Params) => getData(newParams)" />
	</app-panel>
</template>

<script lang="ts" setup>
	import LoadTable from '@/components/datatables/yard-app/load/LoadTable.vue'
	import { ref, onMounted } from 'vue'
	import ContractService from '@/services/contract'
	import useAuthStore from '@/stores/auth'
	import useToasterStore from '@/stores/toaster'
	import type { ContractItem } from '@/data/schema/contract-item'
	import { formatItemsDates } from '@/utils/date'
	import type { Params } from '@/data/types/datatable'
	import { useDatatable } from '@/composables/datatable'

	// Resources
	const api = new ContractService()
	const auth = useAuthStore()
	const toaster = useToasterStore()

	// Data
	const loading = ref(true)
	const items = ref<ContractItem[]>([])

	// Paging
	const { total, params } = useDatatable()

	const getData = (newParams?: Params) => {
		loading.value = true

		if (newParams) {
			params.value = newParams
		}

		const page = params.value.page
		const per_page = params.value.rowsPerPage

		if (auth.user?.assigned_depots) {
			const encodedDepots = auth.user.assigned_depots
				.map((value) => encodeURIComponent(value))
				.join('|')

			api.getYardAppArea(auth.user.id, 'load-delivery', encodedDepots, page, per_page, {
				withItemWeight: true,
				withItemCount: true
			})
				.then((res) => {
					loading.value = false
					items.value = formatItemsDates(res.data.data)
					if (res.data.meta && res.data.meta.paging && res.data.meta.paging.total) {
						total.value = Number(res.data.meta.paging.total)
					} else {
						total.value = 0
					}
				})
				.catch((error) => {
					console.error(error)
					toaster.error({ text: `An error occurred retrieving load details` })
					loading.value = false
				})
		} else {
			loading.value = false

			if (!auth.user?.assigned_depots) {
				console.warn('Authenticated user has no assigned depots')
			}
		}
	}

	onMounted(() => {
		getData()
	})
</script>
